import { cn } from '@lensora/ui'
import { motion } from 'framer-motion'
import * as React from 'react'

interface ChatMessageProps {
  role: 'assistant' | 'user'
  children: React.ReactNode
  className?: string
}

// Plain-text bubble primitive — never renders markup. Callers must never
// pass dangerouslySetInnerHTML-derived children; any scraped/LLM-derived
// copy (industry, niche, competitors) is attacker-influenceable and must
// stay as text nodes only.
//
// One sanctioned exception: the demo_response turn's simulate response text
// is real LLM-derived content that needs genuine markdown rendering (it's
// the Prompts page's own response format). That text is rendered via
// PlatformResponseBody's dedicated, reviewed ReactMarkdown path — no
// rehype-raw, no dangerouslySetInnerHTML — never through this component's
// children or through renderBoldSegments.
export function ChatMessage({ role, children, className }: ChatMessageProps) {
  const isUser = role === 'user'
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.22, ease: [0.32, 0, 0.68, 1] }}
      className={cn('flex', isUser ? 'justify-end' : 'justify-start')}
    >
      <div
        className={cn(
          'max-w-[85%] rounded-2xl px-4 py-2.5 text-sm',
          isUser ? 'bg-brand-primary text-text-inverse' : 'bg-surface-overlay text-text',
          className
        )}
      >
        {children}
      </div>
    </motion.div>
  )
}
